// The merchant's message for a bulk save with failed rows: the count, then WHY.
//
// Every bulk endpoint answers `{results: [{id, success, error?}], summary}`, and
// a failed row's `error` is an English sentence the merchant reads (the
// BULK_ROW_* contract and `validation_sentence` in backend/core/exceptions.py).
// The reasons are shown distinct, in first-seen order, because 200 rows failing
// one way is one thing to tell the merchant. A row without an `error` string
// counts, and gives no reason.
const MAX_REASONS = 3;

export function failedRowsMessage(t, results) {
  const failed = results.filter((row) => !row.success);
  const reasons = [];
  failed.forEach((row) => {
    const reason = typeof row.error === 'string' ? row.error.trim() : '';
    if (reason && !reasons.includes(reason)) reasons.push(reason);
  });
  const parts = [
    t('dataHealth.rowsFailed', { count: failed.length }),
    ...reasons.slice(0, MAX_REASONS),
  ];
  if (reasons.length > MAX_REASONS) {
    parts.push(t('dataHealth.rowsFailedMore', { count: reasons.length - MAX_REASONS }));
  }
  return parts.join(' ');
}
